import Navigation from './Navigation'

(function () {
    class VoucherSideSheet extends Navigation {
        constructor(container, type) {
            super(container)
            this.type = type
            this.appendClassName = !this.isMobile ? 'voucher-menu' : 'voucher-mobile-menu'
            this.triggers = document.querySelectorAll("[href='#voucher-nav']")
            this.$nav = document.querySelector('#voucher-nav')
            
            this.$navItems = []
            this.$staggerItems = this.$el.querySelectorAll('.main-nav__item, .top-links-mobile, .main-nav__list > .sub-nav__item, .main-nav__item > .sub-nav__list > .sub-nav__item')
            this.tweening = false
            this.init()
        }

        createAnim() {
            this.killMainTl()
            this.createMainTl()
            this.tl.add(this.openSideNav())
        }

        triggerHtmlUpdater(){
            super.triggerHtmlUpdater();
            // For parent menu toggling
            if(this.isMobile) {
                const mainMenuToggler = document.querySelector('.action-link--menu')
                this.active ? mainMenuToggler.classList.add('open', 'no-pointer-events') : mainMenuToggler.classList.remove('open', 'no-pointer-events')
            }
            
        }

        addListeners() {
            super.addListeners()
            if(this.isMobile) {
                const mainMenuTriggerList = document.querySelector('.action-list__item--menu')
                mainMenuTriggerList.addEventListener("click", () => this.active && this.close())
            }
        }
    } 

    document.querySelector('#voucher-nav') && new VoucherSideSheet(document.querySelector('#voucher-nav'), 'side-nav')

})()
